import type { SmeCompany } from '@/types';
import { getSme } from '@/utils/request';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSmeCompaniesStore = defineStore('sme-companies', () => {
  const companies = ref<SmeCompany[]>([]);

  const getCompanies = async (): Promise<SmeCompany[]> => {
    const data = await getSme('/companies');
    companies.value = data;
    return data;
  };

  return {
    companies,
    getCompanies,
  };
});
